/* eslint-disable @typescript-eslint/no-explicit-any */

import FilterConfirmability from './FilterConfirmability';
import FilterRestrictions from './FilterRestrictions';
import FilterLtExtras from './FilterLtExtras';
import FilterPaymentBenefits from './FilterPaymentBenefits';
import FilterTravelBenefits from './FilterTravelBenefits';
import FilterCancellationPolicy from './components/FilterCancellationPolicy';
import FilterPrices from './FilterPrices';
import FilterStars from './FilterStars';
import FilterHotelName from './FilterHotelName';
import FilterRating from './FilterRating';
import FilterLine from './FilterLine';
import FilterBeachType from './FilterBeachType';
import FilterBeachSurface from './FilterBeachSurface';
import FilterMeals from './FilterMeals';
import FilterRegions from './FilterRegions';
import FilterCategory from './FilterCategory';
import FilterWiFi from './FilterWiFi';
import FilterSpa from './FilterSpa';
import FilterSuperCashback from './FilterSuperCashback';
import FilterFacilities from './FilterFacilities';
import FilterFamilyWithKids from './FilterFamilyWithKids';
import FilterOperators from './FilterOperators';
import FilterSkiDistance from './FilterSkiDistance';
import FilterTypePlacement from './FilterTypePlacement';
import FilterCountries from './FilterCountries';

export const FILTERS: any = {
  FilterConfirmability,
  FilterCancellationPolicy,
  FilterSuperCashback,
  FilterLtExtras,
  FilterPaymentBenefits,
  FilterTravelBenefits,
  FilterStars,
  FilterMeals,
  FilterRating,
  FilterLine,
  FilterRegions,
  FilterTypePlacement,
  FilterPrices,
  FilterHotelName,
  FilterBeachType,
  FilterBeachSurface,
  FilterOperators,
  FilterRestrictions,
  FilterCategory,
  FilterCountries,
  FilterWiFi,
  FilterSpa,
  FilterFacilities,
  FilterFamilyWithKids,
  FilterSkiDistance,
};

export const FILTERS_LIST = Object.values(FILTERS) as any;
